import {
  readLastGroup,
  readOpenGroups,
  writeLastGroup,
  writeOpenGroups,
} from '@/shared/features/groups/storage/group-tree-storage/group-tree-storage';
import { TLastGroup } from '@/shared/features/groups/storage/group-tree-storage/group-tree-storage.types';
import { selectUser } from '@/shared/redux/api/auth/auth-api';
import { useAppSelector } from '@/shared/redux/hooks/hooks';

// Reads go straight to storage, not React state: the tree only reads them when
// it mounts, and the writes come from the reader's own clicks.
export const useGroupTreeStorage = () => {
  const user = useAppSelector(selectUser);
  const tenantId = user?.attributes?.['custom:tenantId'] ?? '';

  return {
    readOpenGroups: () => readOpenGroups(tenantId),
    saveOpenGroups: (openGroupIds: string[]) =>
      writeOpenGroups(tenantId, openGroupIds),
    readLastGroup: () => readLastGroup(tenantId),
    saveLastGroup: (lastGroup: TLastGroup) =>
      writeLastGroup(tenantId, lastGroup),
  };
};
